import React, { Component } from 'react';
import { currentActionGrid } from '../../Common/ActionHexUtilities';
import { get_points_for_card } from '../../Common/CardUtilities';
import Grid2d from '../../Common/Grid2d';
import { getCardTextureUrl, getFactionTextureUrl, getTextureUrl } from '../../Common/TextureTools';
import '../../Controls/competitor-board.css';
import '../Controls/hotel-interface.css';
import './hotel-observer.css';
import '../Controls/inventory-selector.css';

import './robots.css';

import blankImage from '../../Common/blank-512x512.png'
import { ASSETS_URL } from '../../../../Settings';


const COLORS = [
    null, 'var(--deep)', 'var(--stem)', 'var(--hex)', 'var(--dread)', 'var(--honored)', 'var(--seed)'
];
const FADED_COLORS = [
    null, 'var(--deep-faded)', 'var(--stem-faded)', 'var(--hex-faded)', 'var(--dread-faded)', 'var(--honored-faded)', 'var(--seed-faded)'
];


class FactionIndicator extends Component {
    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let factionId = gamePlayerData.faction;
        let src;
        if (factionId) {
            src = getFactionTextureUrl(factionId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }


        return <div>
            <img
                src={src}
                alt="room"
                width={this.props.radius * 2.26}
                height={this.props.radius * 2.26}
                style={{position: 'absolute', top: this.props.offsetTop, left: this.props.offsetLeft}}
            />
        </div>;

    }
}


class ActivatedRoom extends Component {
    constructor(props) {
        super(props);
        this.src = getTextureUrl(157);
    }
    render() {
        const src = this.src;
        const activatedCount = this.props.activated;
        const locked = this.props.locked;
        let baseClassName = 'activated-robot';
        let parentClassName = 'activated-robot-parent'
        if (!locked) {
            baseClassName += ' animate-robot'
            parentClassName += ' animate-robot-parent'
        }

        return <div className={'robot-activated-room-container'}>

            <div className={parentClassName}
                style={{
                    width: this.props.width/2,
                    height: this.props.width/2,
                    top: this.props.width/4,
                    left: this.props.width/4,
                }}
            >
                <div className={baseClassName + ' activated-robot-0'}>
                    <img
                        src={src}
                        alt="robot"
                        className={'activated-room-robot'}
                        style={{ width: this.props.width / 4 }}
                    />
                </div>
                {activatedCount > 1 &&
                    <div className={baseClassName + ' activated-robot-1'}>
                        <img
                            src={src}
                            alt="robot"
                            className={'activated-room-robot'}
                            style={{ width: this.props.width / 4 }}
                        />
                    </div>
                }
                {activatedCount > 2 &&
                    <div className={baseClassName + ' activated-robot-2'}>
                        <img
                            src={src}
                            alt="robot"
                            className={'activated-room-robot'}
                            style={{ width: this.props.width / 4 }}
                        />
                    </div>
                }
            </div>
        </div>;
    }
}


class StationRoom extends Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    assignRef = (ref) => {
        this.ref = ref;
    }

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let station = gamePlayerData.station;
        let roomIndex = this.props.roomIndex;
        let roomId = station[roomIndex];
        let src;
        if (roomId) {
            src = getTextureUrl(roomId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }

        let activated = false;
        if (gamePlayerData.robot_assignments.includes(roomIndex)) {
            activated = gamePlayerData.robot_assignments.filter(assignment => assignment === roomIndex).length;
        }
        let locked = false;
        if (roomId && gamePlayerData.locked_rooms.includes(roomIndex)) {
            locked = true;
        }

        return <div ref={this.assignRef}>
            <img src={src} alt={'room'}
                 width={this.props.width}
                 height={this.props.width}
            />
            {activated && <ActivatedRoom activated={activated} locked={locked} onClick={this.onClick} {...this.props} />}
            {locked && <div className={'hotel-interface-locked-room'} />}
        </div>;
    }
}

class DockCard extends Component {

    render() {
        let gamePlayerData = this.props.gamePlayerData;
        let docks = gamePlayerData.docks;
        let dockIndex = this.props.dockIndex;
        let cardId = docks[dockIndex];

        // let points = gamePlayerData.docks_extended[dockIndex];
        let station = gamePlayerData.station;
        let robot_assignments = gamePlayerData.robot_assignments;
        let lodging = gamePlayerData.lodging;
        let calculatedPoints = get_points_for_card(
            station, robot_assignments, lodging, cardId, dockIndex);
        // if (calculatedPoints.satisfied) {
        //     if (calculatedPoints.points !== points) console.error('Point Miscalculation.', cardId, points, calculatedPoints.points, calculatedPoints.statement);
        // }
        let points = calculatedPoints.points;
        let isDanger = points === 'Danger';
        let pointsClassName = 'docked-card-points';
        if (isDanger) {
            pointsClassName += ' docked-card-points--danger';
        }

        let src;
        if (cardId) {
            src = getCardTextureUrl(cardId);
        } else {
            src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
        }

        let cardWidth = this.props.width / 3.33;
        let cardHeight = cardWidth / 1.4;

        let style = {width: cardWidth, height: cardHeight};
        let offset = '0.23%'
        if (dockIndex === 0) style['top'] = offset;
        if (dockIndex === 0) style['right'] = offset;
        if (dockIndex === 1) style['right'] = offset;
        if (dockIndex === 1) style['bottom'] = offset;
        if (dockIndex === 2) style['left'] = offset;
        if (dockIndex === 2) style['bottom'] = offset;
        if (dockIndex === 3) style['left'] = offset;
        if (dockIndex === 3) style['top'] = offset;

        return <div id={`dock-${dockIndex}`}
                    className={'dock'}
                    style={style}
        >
            <div id={'dock-card'} className={'docked-card-container'}>
                <img
                    src={src}
                    alt="card"
                    className={'docked-card'}
                />
                {points !== 0 && <div id={'docked-card-points'}
                                      className={pointsClassName}>
                    {!isDanger && <div id={'docked-card-point-text'}
                                       className={'docked-card-point-text'}>{points}</div>}
                </div>
                }
            </div>
        </div>;
    }
}

class StaffMarket extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1
        };
        this.grid = new Grid2d(40, false);
        this.element = null;
        this.fillGrid();
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.element);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    setWidth = () => {
        let width = this.element.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.35;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
            });
    }

    item = (robotId) => {
        if (!robotId) return <></>;
        let textureId = 157;
        return <img
            src={getTextureUrl(textureId)}
            alt="robot"
            style={{ width: this.state.radius * 2 }}
        />;
    };

    fillGrid = () => {
        this.props.gamePlayerData.robot_market.forEach((robotId, index) => {
            this.grid.moveItemToGridId(this.item(robotId), index);
        });
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }


    render() {
        return <div className={'staff-market-anchor'} ref={(ref) => {this.element=ref}}>
            <div className={'staff-market-container'}>
                {this.getGrid()}
            </div>
        </div>;
    }
}

class AvailableStaff extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1
        };
        this.grid = new Grid2d(40, false);
        this.element = null;
        this.fillGrid();
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.element);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    setWidth = () => {
        let width = this.element.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.35;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
            });
    }

    item = (robotId) => {
        if (!robotId) return <></>;
        let textureId = 157;
        return <img
            src={getTextureUrl(textureId)}
            alt="robot"
            style={{ width: this.state.radius * 2 }}
        />;
    };

    fillGrid = () => {
        this.props.gamePlayerData.robot_storage.forEach((robotId, index) => {
            this.grid.moveItemToGridId(this.item(robotId), index);
        });
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }


    render() {
        return <div className={'staff-market-anchor'} ref={(ref) => {this.element=ref}}>
            <div className={'staff-market-container'}>
                {this.getGrid()}
            </div>
        </div>;
    }
}

class AvailableItems extends Component {
    render() {
        let availableItems = [...this.props.gamePlayerData.storage];
        availableItems = availableItems.filter(roomId => roomId != null);
        const newActionGrid = currentActionGrid(this.props.gamePlayerData);
        availableItems = [ ...newActionGrid, ...availableItems];
        while (availableItems.length < 12) availableItems.push(null);
        return <div
            id={'action-stack-anchor'}
            className={'hotel-action-stack-anchor'}
        >
            <div id={'hotel-action-stack'}
                 className={'hotel-action-stack'}
            >
                    {availableItems.map(
                        (roomId, index) => {
                            let src=blankImage;
                            if (roomId) {
                                src = getTextureUrl(roomId);
                            }
                            return <div id={'hotel-action-stack-item'} key={index}
                                        className={'hotel-action-stack-item'}
                            >
                                <img
                                    src={src}
                                    alt="room"
                                />
                            </div>;
                        })}
                </div>
        </div>;
    }
}
class ObserverHotelLodging extends Component {
    render() {
        return <div
            id={'action-stack-anchor'}
            className={'hotel-action-stack-anchor'}
        >
            <div id={'hotel-action-stack'}
                 className={'hotel-action-stack'}
            >
                    {this.props.gamePlayerData.lodging.map(
                        (roomId, index) => {
                            let src=blankImage;
                            if (roomId) {
                                src = getTextureUrl(roomId);
                            }
                            return <div id={'hotel-action-stack-item'} key={index}
                                        className={'hotel-action-stack-item'}
                            >
                                <img
                                    src={src}
                                    alt="room"
                                />
                            </div>;
                        })}
                </div>
        </div>;
    }
}



export default class HotelObserver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500*1.144,
            radius: 500*0.1,
            gamePlayerData: props.gamePlayerData,
        };

        this.eventName = `game-player-${props.gamePlayerData.seat}-event`;
        this.interface = null;
        this.grid = new Grid2d(27, true);
        this.fillGrid();
        this.allowUpdate = true;
    }

    componentDidMount() {
        this.setWidth();
        this.resizeObserver = new ResizeObserver(this.setWidth);
        this.resizeObserver.observe(this.interface);
        window.addEventListener(this.eventName,
            this.gamePlayerEventListener);
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        window.removeEventListener(this.eventName,
            this.gamePlayerEventListener);
    }

    // A HotelObserver renders one player and subscribes to that player's
    // per-seat event stream. If this instance is ever handed a DIFFERENT
    // player via props (a reused competitor cell, or a slot whose occupant
    // changed), the constructor's one-time seed + own-seat listener would
    // leave it frozen on the original player — the duplicate-board bug.
    // Re-seed the displayed data whenever the prop identity diverges from
    // what we're showing; componentDidUpdate re-points the listener.
    static getDerivedStateFromProps(props, state) {
        if (props.gamePlayerData
                && (!state.gamePlayerData
                    || state.gamePlayerData.id !== props.gamePlayerData.id)) {
            return { gamePlayerData: props.gamePlayerData };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        // Re-point the per-seat subscription when this cell's player
        // changed seats (only reachable if an instance is reused across
        // players — stable keys upstream normally prevent it, but the
        // board must stay correct even when they don't).
        const prevSeat = prevProps.gamePlayerData
            ? prevProps.gamePlayerData.seat : undefined;
        const nextSeat = this.props.gamePlayerData
            ? this.props.gamePlayerData.seat : undefined;
        if (prevSeat !== nextSeat) {
            window.removeEventListener(
                `game-player-${prevSeat}-event`, this.gamePlayerEventListener);
            this.eventName = `game-player-${nextSeat}-event`;
            window.addEventListener(
                this.eventName, this.gamePlayerEventListener);
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        // A different player handed to this slot must always render
        // (getDerivedStateFromProps has already re-seeded the state, and
        // componentDidUpdate will re-point the event subscription).
        if (this.props.gamePlayerData.id !== nextProps.gamePlayerData.id) {
            return true;
        }
        // The competitor-target highlight is a prop toggle, not a
        // gamePlayerData event, so allowUpdate can be false when it
        // flips. Force a render on that one prop so the ring
        // appears/disappears when targeting opens/closes.
        if (this.props.isTargetCandidate !== nextProps.isTargetCandidate) {
            return true;
        }
        return this.allowUpdate;
    }

    gamePlayerEventListener = (e) => {
        this.allowUpdate = true;
        this.setState({gamePlayerData: e.detail});
    }


    setWidth = () => {
        this.allowUpdate = true;
        let width = this.interface.offsetWidth;
        let height = width * 1.144;
        let radius = width * 0.108;
        this.grid.updateRadius(radius);
        this.setState({ width: width, height: height, radius: radius},
            () => {
                this.fillGrid();
        });
    }

    fillGrid = () => {
        let station = [ 1, 2, 3, 4, 5, 6, ];
        let beds = [ 9, 11, 15, 17];
        // let lodging = [ 31, 15, 14, 12, 11, 25 ];
        // let docks = [56, 58, 40, 42];
        // let docks = [33, 35, 21, 23];
        let total = [ ...station, ...beds ];
        total.forEach((gridId, index) => {
            // let element = this.room(index);
            let element = <StationRoom {...this.state}
                                       roomIndex={index}
                                       width={this.state.radius * 2.26}
                                       callback={this.state.callback}
            />
            this.grid.moveItemToGridId(element, gridId);
        });
    };

    getGrid = () => {
        this.fillGrid();
        return this.grid.render();
    }

    render() {
        // console.log('RENDER OBSERVER ***********', this.props.gamePlayerData.seat);
        this.allowUpdate = false;
        let colorLibrary = COLORS;
        if (!this.props.isActive) {
            colorLibrary = FADED_COLORS;
        }
        let color = colorLibrary[this.state.gamePlayerData.faction];

        let offsetTop = -1.132 * this.state.radius;
        let offsetLeft = -1.135 * this.state.radius;
        // Competitor-target affordance (additive, default off). When a
        // target pick is open and this board is eligible, light up the
        // container and make it clickable — a second path alongside the
        // action window's own swiper. When false/undefined the root
        // renders byte-for-byte as before: no class change, no onClick.
        const isTargetCandidate = !!this.props.isTargetCandidate;
        const onTargetClick = this.props.onTargetClick;
        let containerClassName = 'hotel-observer-container';
        if (isTargetCandidate) {
            containerClassName +=
                ' hotel-observer-container--target-candidate';
        }
        return (<div className={containerClassName}
                     style={{background: color}}
                     onClick={isTargetCandidate ? onTargetClick : undefined}>
                <ObserverHotelLodging gamePlayerData={this.state.gamePlayerData}/>
            <div id={'hotel-interface'}
                 className={'hotel-observer'}
                 ref={(ref) => {this.interface=ref}}
            >
                {/* <StorageStack gamePlayerData={gamePlayerData}/> */}
                <div id={'hotel-center'} className={'hotel-center'}>
                    <div style={{position: 'absolute', top: offsetTop, left: offsetLeft}}>
                        {this.getGrid()}
                    </div>
                </div>
                <div id={'hotel-center'} className={'hotel-center'}>
                    <FactionIndicator {...this.state} offsetTop={offsetTop} offsetLeft={offsetLeft}/>
                </div>
                <div id={'docks'} className={'docks'}>
                    <DockCard {...this.state} dockIndex={0}/>
                    <DockCard {...this.state} dockIndex={1}/>
                    <DockCard {...this.state} dockIndex={2}/>
                    <DockCard {...this.state} dockIndex={3}/>
                </div>
                <div id={'staff'} className={'hotel-interface-staff-market'}>
                    <StaffMarket {...this.state} />
                </div>
                <div id={'staff'} className={'hotel-interface-available-staff'}>
                    <AvailableStaff {...this.state} />
                </div>
                <div id={'score'} className={'hotel-interface-score-bars'}>

                </div>
                <div id={'message'} className={'hotel-interface-message'}>

                </div>
                <img
                    id={'hotel-interface-background'}
                    src={`${ASSETS_URL}ui/HotelGrid2-01272023.png`}
                    alt="action"
                    className={'hotel-interface-background'}
                />
            </div>
            <AvailableItems gamePlayerData={this.state.gamePlayerData}/>
            </div>
        )
    }
}
